import React, { Component } from "react";
import ReactDOM from "react-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Paper from "material-ui/Paper";
import ReactMarkdown from "react-markdown";
import Flow from "./Flow";
import StateChanger from "./StateChangerOld";
import StatePreview from "./StatePreview";
import SpecText from "./SpecText";
import UiComp from "./UiComp";
import dagreD3 from "dagre-d3";
import * as d3 from "d3";
import "./styles.css";

class State extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  componentDidMount() {
    if (
      !this.props.state ||
      (!this.props.state.flows && !this.props.state.execs)
    )
      return;

    var that = this;
    let render = dagreD3.render();
    // Left-to-right layout
    var g = new dagreD3.graphlib.Graph({ compound: true });

    g.setGraph({
      nodesep: 20,
      ranksep: 16,
      rankdir: "LR",
      marginx: 10,
      marginy: 10
    });
    g.setNode(-99, {
      labelType: "html",
      label: "<span  style='color:white; padding: 15px'>UI-Events</span>",
      rx: 5,
      ry: 5,
      padding: 0,
      class: "uiSourceNode"
    });
    g.setNode("output_ui_state", {
      label: "UI",
      clusterLabelPos: "top",
      style: "fill: #d3d7e8"
    });
    g.setNode("output_execs", {
      label: "Executions",
      clusterLabelPos: "top",
      style: "fill: #ffd47f;"
    });
    g.setParent("output_execs", "output_ui_state");

    function findUiEvent(eventId) {
      var events = that.props.uievents;
      for (let j = 0; j < events.length; j++) {
        var event = events[j];
        if (event.id === eventId) return event;
      }
    }
    function findGlobal(id) {
      var globals = that.props.globals;
      for (let j = 0; j < globals.length; j++) {
        var global = globals[j];
        if (global.id === id) return global;
      }
    }
    function findOtherFlowOutput(id) {
      var flows = that.props.state.flows;
      for (let j = 0; j < flows.length; j++) {
        var flow = flows[j];
        if (flow.id === id) {
          if (flow.typesOutput) return flow.typesOutput[0];
          if (flow.signalOutput) return flow.signalOutput[0];
        }
      }
    }
    function processNode(flow, type) {
      var uiAttr = "",
        uiOut = "";
      if (type === "ui") {
        if (flow.attr) {
          for (let j = 0; j < flow.attr.length; j++) {
            var attr = flow.attr[j];
            uiAttr =
              "<div style='padding:6px;'>" +
              "<span style='background: #fff;padding:6px;font-size: 14px;color:black'>" +
              attr.binding +
              " -></span>" +
              "<span style='background: #cf0;padding:6px;font-size: 14px;color:black'>" +
              attr.name +
              "</span>" +
              "</div>";
          }
        }
        if (flow.events) {
          for (let j = 0; j < flow.events.length; j++) {
            var event = flow.events[j];
            uiOut =
              "<div><span style='margin:6px;background: #d2d;border-radius: 5px;line-height: 1.0;font-size: 12px;padding:2px;'>" +
              event.name +
              "-></span></div>";
          }
        }
      }
      var spec = "";
      if (type === "nothing")
        spec =
          "</br><span style='color:red; font-size:12px;'>" +
          flow.spec.substring(0, 50) +
          "</span>";
      var details = spec + uiAttr + uiOut;
      g.setNode(flow.id, {
        labelType: "html",
        label:
          "<div class='wrapword' style='width: 200px; color:white; padding: 10px'><span>" +
          flow.title +
          "</span>" +
          details +
          "</div>",
        rx: 5,
        ry: 5,
        padding: 0,
        class: "flowNode",
        flow: flow
      });
      if (flow.input) {
        for (let j = 0; j < flow.input.length; j++) {
          var input = flow.input[j];
          var sourceId,
            label = "XYZ";
          if (input.type === "flow") {
            sourceId = input.id;
            label = findOtherFlowOutput(input.id).name;
          } else if (input.type === "ui") {
            sourceId = -99;
            label = findUiEvent(input.id).name;
          } else if (input.type === "global") {
            //sourceId = -999;
            label = findGlobal(input.id).title;
          }
          var className = "none";
          if (input.type === "ui") className = "uiInput";
          var labelStyle = "";
          if (input.type === "ui") labelStyle = "fill: #d2d";
          if (sourceId)
            g.setEdge(sourceId, flow.id, {
              label: label,
              class: className,
              labelStyle: labelStyle
            });
        }
      }
      if (type === "exec") g.setParent(flow.id, "output_execs");
      if (type === "ui") g.setParent(flow.id, "output_ui_state");
    }
    var flows = this.props.state.flows;
    for (let i = 0; i < flows.length; i++) {
      processNode(flows[i], "flow");
    }
    var execs = this.props.state.execs;
    for (let i = 0; i < execs.length; i++) {
      processNode(execs[i], "exec");
    }
    var uis = this.props.state.ui;
    for (let i = 0; i < uis.length; i++) {
      processNode(uis[i], "ui");
    }

    /*g.setEdge(1, 2, {
      label: "Number of Products",
      width: 80
    });
    g.setEdge(3, 1, edgeParams);*/
    var svg = d3.select("svg");
    var inner = d3.select("svg g");
    var zoom = d3.zoom().on("zoom", function() {
      inner.attr("transform", d3.event.transform);
    });
    svg.call(zoom);
    inner.call(render, g);

    // Zoom and scale to fit
    var graphWidth = g.graph().width + 80;
    var graphHeight = g.graph().height + 40;
    var width = 1500;
    var height = 800;
    var zoomScale = Math.min(width / graphWidth, height / graphHeight);
    var translateX = width / 2 - (graphWidth * zoomScale) / 2;
    var translateY = height / 2 - (graphHeight * zoomScale) / 2;
    svg.call(
      zoom.transform,
      d3.zoomIdentity.translate(translateX, translateY).scale(zoomScale)
    );

    inner
      .selectAll("g.node")
      /*.attr("title", function(v) {
        return styleTooltip(v, g.node(v).description);
      })*/
      .each(function(v) {
        this.onclick = function(v) {
          console.log("clicked " + ReactDOM.findDOMNode(this));
          //ReactDOM.findDOMNode(this).append("<h2>append to div in parent?</h2>")
        };
        if (g.node(v).flow) {
          //this.append(<Flow flow={g.node(v).flow}/>)
          //ReactDOM.findDOMNode(this).append("<h2>append to div in parent?</h2>")
          console.log("node " + v + " " + g.node(v).flow.title);
        }
        //$(this).tipsy({ gravity: "w", opacity: 1, html: true });
      });
  }

  render() {
    if (!this.props.state) return "";
    var that = this;
    let images;
    if (this.props.state.images)
      images = this.props.state.images.map(image => {
        return (
          <div
            style={{
              width: "auto",
              height: 700,
              overflowY: "scroll"
            }}
          >
            <img src={image} style={{ width: 300 }} />
          </div>
        );
      });
    else images = "";
    let uiComps;
    if (!this.props.state.ui) {
      uiComps = "";
    } else {
      uiComps = (
        <div
          style={{
            margin: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "top",
            width: "fit-content"
          }}
        >
          {this.props.state.ui.map(ui => {
            if (ui.state)
              return (
                <span style={{ margin: 10 }}>
                  <Paper
                    style={{ padding: 12, width: "100%", textAlign: "center" }}
                  >
                    <StatePreview
                      state={ui.state}
                      uievents={that.props.uievents}
                    />
                  </Paper>
                </span>
              );
            else
              return (
                <UiComp
                  comp={ui}
                  uievents={this.props.uievents}
                  globals={this.props.globals}
                  state={this.props.state}
                  onGoToState={that.props.onGoToState}
                />
              );
          })}
        </div>
      );
    }
    let flows;
    if (
      !this.props.state.flows
      //|| !this.state.expanded
    ) {
      flows = "";
    } else {
      flows = (
        <svg
          class="live map"
          style={{ width: 1500, height: 800, background: "#eeeeee" }}
        >
          <g />
        </svg>
        //""
      );
      /*flows = (
        <div
          style={{
            padding: 0,
            width: "fit-content",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div>
            {this.props.state.flows.map(flow => {
              console.log("flow: " + flow.name);
              return (
                <Paper>
                  <Flow
                    flow={flow}
                    allFlows={this.props.state.flows}
                    uievents={this.props.uievents}
                  />
                </Paper>
              );
            })}
          </div>
        </div>
      );*/
    }
    let stateChanger;
    if (!this.props.state.stateChangers || !this.state.expanded) {
      stateChanger = "";
    } else {
      stateChanger = (
        <div
          style={{
            padding: 20,
            width: "fit-content",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div>
            {this.props.state.stateChangers.map(stateChanger => {
              return (
                <p>
                  <StateChanger
                    stateChanger={stateChanger}
                    allFlows={this.props.state.flows}
                    uievents={this.props.uievents}
                    eventsOutput={this.props.state.eventsOutput}
                  />
                </p>
              );
            })}
          </div>
        </div>
      );
    }
    function drawAttr(attr) {
      if (!attr.state)
        return (
          <div style={{ fontSize: 14, padding: 4 }}>
            {attr.name}
            <span style={{ paddingLeft: 14, fontSize: 10 }}>{attr.type}</span>
          </div>
        );
      else {
        return (
          <div style={{ padding: 2, width: "100%" }}>
            <State
              state={attr.state}
              uievents={that.props.uievents}
              globals={this.props.globals}
            />
          </div>
        );
      }
    }
    function drawEvent(event) {
      let attributes;
      if (event.attributes)
        attributes = (
          <div>
            {event.attributes.map(attr => {
              return (
                <Paper style={{ padding: 2, width: "100%", textAlign: "left" }}>
                  {drawAttr(attr)}
                </Paper>
              );
            })}
          </div>
        );
      else attributes = "";
      let actions;
      if (event.actions)
        actions = (
          <div>
            {event.actions.map(attr => {
              return (
                <Paper
                  style={{
                    padding: 4,
                    marginTop: 10,
                    width: "100%",
                    textAlign: "left"
                  }}
                >
                  <div
                    style={{
                      fontSize: 14,
                      color: "#ddaaaa",
                      lineHeight: 1,
                      padding: 4
                    }}
                  >
                    {attr.name}
                    <span style={{ paddingLeft: 14, fontSize: 10 }}>
                      {attr.type}
                    </span>
                  </div>
                </Paper>
              );
            })}
          </div>
        );
      else actions = "";
      let name;
      if (event.name)
        name = (
          <span
            style={{
              color: "#dd22dd",
              lineHeight: 1.0,
              fontSize: 12,
              padding: 2
            }}
          >
            {event.name} {"->"}
          </span>
        );
      else name = "";
      return (
        <div
          style={{
            paddingLeft: 60,
            paddingBottom: 4,
            paddingTop: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "right",
            alignItems: "right",
            width: "fit - content"
          }}
        >
          {name}
          {attributes}
          {actions}
        </div>
      );
    }
    let stateParams;
    if (!this.props.state.eventsOutput) {
      stateParams = "";
    } else {
      stateParams = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "fit - content"
          }}
        >
          {this.props.state.eventsOutput.map(event => {
            return drawEvent(event);
          })}
        </div>
      );
    }
    let detailSpecText;
    if (!this.props.state.spec) detailSpecText = "";
    else
      detailSpecText = (
        <SpecText
          spec={this.props.state.spec}
          allFlows={this.props.state.flows}
          uievents={this.props.uievents}
          eventsOutput={this.props.state.eventsOutput}
        />
      );
    detailSpecText = "";
    let stateDetails;
    if (!this.state.expanded)
      stateDetails = <div style={{ color: "#cccccc" }}>(+)</div>;
    else
      stateDetails = (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "fit-content"
          }}
        >
          {flows}
          {stateChanger}
        </div>
      );
    return (
      <div>
        <div
          style={{
            margin: 10,
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center"
          }}
        >
          {this.props.state.title}
        </div>
        <div
          style={{
            margin: 20,
            textAlign: "center"
          }}
        >
          {detailSpecText}
        </div>
        <div
          onClick={e => {
            e.stopPropagation();
            this.handleClick(e);
          }}
          style={{
            padding: 6,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "fit-content"
          }}
        >
          {flows}
          &nbsp;&nbsp;&nbsp;
          {images}
        </div>
      </div>
    );
  }
}

export default State;



// WEBPACK FOOTER //
// ./src/components/StateOld.js